import { render, staticRenderFns } from "./CaptiveFormsListItem.vue?vue&type=template&id=3da01a3f&scoped=true"
import script from "./CaptiveFormsListItem.vue?vue&type=script&lang=js"
export * from "./CaptiveFormsListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da01a3f",
  null
  
)

export default component.exports